(function () {
  if (window.__pgAboutArtistLinkBound) return;
  window.__pgAboutArtistLinkBound = true;
  document.documentElement.setAttribute('data-pg-about-artist-script', 'ready');

  function isUsable(element) {
    if (!element || element.closest('[aria-hidden="true"]')) return false;

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function findAboutArtistControl() {
    var controls = Array.prototype.slice
      .call(
        document.querySelectorAll(
          '.easytabs-accordion-item[role="button"], .easytabs-tab-item[role="tab"]'
        )
      )
      .filter(function (element) {
        return (element.textContent || '').trim() === 'About the Artist';
      });

    var usableControls = controls.filter(isUsable);

    return (
      usableControls.find(function (element) {
        return element.matches('.easytabs-accordion-item');
      }) ||
      usableControls.find(function (element) {
        return element.matches('.easytabs-tab-item');
      }) ||
      usableControls[0] ||
      null
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var link =
        target && target.closest
          ? target.closest('.pg-about-artist-link')
          : null;

      if (!link) return;

      event.preventDefault();

      var control = findAboutArtistControl();
      if (!control) return;

      control.id = 'pg-about-the-artist';

      if (
        control.getAttribute('aria-expanded') === 'false' ||
        control.getAttribute('aria-selected') === 'false'
      ) {
        control.click();
      }

      window.setTimeout(function () {
        control.scrollIntoView({ behavior: 'smooth', block: 'start' });
        try {
          control.focus({ preventScroll: true });
        } catch (error) {
          control.focus();
        }
      }, 150);
    },
    true
  );
})();